import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import axios from "axios";
import { toast } from "react-toastify";
import CustomTable from "../../components/customTable/CustomTable";
import DateStartAndEndSame from "../../components/customTable/DateStartAndEndSame";
import { createMRTColumnHelper } from "material-react-table";
import { useMediaQuery, useTheme } from "@mui/material";
import axiosInstance from "../../utils/axiosInstance";

export default function TransactionTable({ type, refinery, metaltype }) {
  const [data, setData] = useState({
    totalCount: 0,
    totalPreTaxAmount: 0,
    data: [],
  });
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = localStorage.getItem("token");

  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };

  const params = {
    type,
    refinery,
    metaltype,
    startDate,
    endDate,
  };
  // console.log("params::::::::::::::::::::::::::::", params);
  const fetchData = async () => {
    try {
      if (!startDate || !endDate) {
        return;
      } else {
        const res = await axiosInstance.get(`/partnertransactionreport`, {
          params,
        });
        // const res = await axios.get(`${baseUrl}/partnertransactionreport`, { params, headers });
        setData({
          totalCount: res.data.totalCount,
          totalPreTaxAmount: res.data.totalPreTaxAmount,
          data: res.data.data || [],
        });
      }
    } catch (err) {
      console.error("Error fetching transactions:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [type, refinery, metaltype, startDate, endDate]);

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    toast.success("Copied to clipboard!");
  };

  const handleDateSearch = (start, end) => {
    setStartDate(start);
    setEndDate(end);
  };

  const columnHelper = createMRTColumnHelper();

  const columns = [
    columnHelper.accessor("client_id", {
      header: "Client ID",
      Cell: ({ row }) => (
        <Tooltip title={row.original?.client_id}>
          <span>
            <IconButton onClick={() => handleCopy(row.original?.client_id)}>
              <ContentCopy />
            </IconButton>
            {row.original?.client_id}
          </span>
        </Tooltip>
      ),
    }),
    // columnHelper.accessor("partner_username", { header: "Username" }),
    columnHelper.accessor("client_name", { header: "Client Name" }),

    columnHelper.accessor("transaction_id", {
      header: "Transaction ID",
    }),
    columnHelper.accessor("merchantTransactionId", {
      header: "Merchant Transaction ID",
      size: 300,

      Cell: ({ row }) => (
        <Tooltip title={row.original?.merchantTransactionId}>
          <span>
            <IconButton
              onClick={() => handleCopy(row.original?.merchantTransactionId)}
            >
              <ContentCopy />
            </IconButton>
            {row.original?.merchantTransactionId}
          </span>
        </Tooltip>
      ),
    }),
    columnHelper.accessor("refinery", { header: "Refinery" }),
    columnHelper.accessor("metaltype", { header: "Metal Type" }),
    columnHelper.accessor("preTax", { header: "Pre-Tax" }),
    columnHelper.accessor("tax", { header: "Tax" }),
    columnHelper.accessor("totalAmount", { header: "Total Amount" }),
    columnHelper.accessor("pmt_type", { header: "Payment Type" }),
    columnHelper.accessor("pmt_status", { header: "Payment Status" }),
    columnHelper.accessor("KYC_status", { header: "KYC Status" }),
    columnHelper.accessor("type", { header: "Type" }),
    columnHelper.accessor("createdAt", { header: "Transaction Date" }),
  ];

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // ✅ Mobile screen check

  return (
    <>
      <Box
        display="flex"
        flexDirection={isMobile ? "column" : "row"}
        justifyContent="space-between"
        alignItems="center"
        mb={0}
      >
        <Box display="flex" gap={1}>
          <Card>
            <CardContent
              sx={{
                backgroundColor: "#4a2a7d",
                color: "#fff",
                paddingTop: 2.5,
              }}
            >
              <Typography sx={{ textAlign: "center" }} variant="body2">
                Total Transactions: <br></br>
                {data.totalCount}
              </Typography>
            </CardContent>
          </Card>
          <Card>
            <CardContent
              sx={{
                backgroundColor: "#4a2a7d",
                color: "#fff",
                paddingTop: 2.5,
              }}
            >
              <Typography variant="body2" sx={{ textAlign: "center" }}>
                Total Amount Of Transactions: <br></br>₹{" "}
                {data.totalPreTaxAmount}
              </Typography>
            </CardContent>
          </Card>
        </Box>
        <Box>
          <DateStartAndEndSame
            onSearch={handleDateSearch}
            defaultStartDate={startDate}
            defaultEndDate={endDate}
          />
        </Box>
      </Box>
      <Box mt={{ xs: 2, md: 0 }}>
        <CustomTable
          columns={columns}
          data={data.data}
          loading={loading}
          permissionKey="PartnerTransaction"
        />
      </Box>
    </>
  );
}
